import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from '@angular/core';
import {NgIf, NgFor, NgClass} from '@angular/common';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatIconModule} from '@angular/material/icon';
import {TranslateModule} from '@ngx-translate/core';
import {Q9TransformPipe} from '@q9elements/ui-kit/common';
import {FormUnit} from '../../../../commands/flowline/flowline.commands';

@Component({
  selector: 'app-form-buttonset',
  templateUrl: './line-form-buttonset.component.html',
  styleUrls: ['./line-form-buttonset.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [NgIf, NgFor, MatIconModule, MatTooltipModule, NgClass, TranslateModule, Q9TransformPipe]
})
export class LineFormButtonsetComponent implements OnInit {
  @Input() public forms: Array<FormUnit>;
  @Input() public selected: string;
  @Output() public setClicked = new EventEmitter<string>();

  private readonly ITEMS_PER_STACK = 3;
  public valid: boolean;
  public stacks: number;

  public select(selection: string) {
    this.setClicked.emit(selection);
  }

  ngOnInit() {
    this.valid = this.forms.length % 3 === 0;
    this.stacks = this.forms.length / 3;
  }

  public getClassForIcon(index: number): {[key: string]: boolean} | undefined {
    return this.stacks === 1 ? this.getSingleStackClass(index) : this.getMultipleStackClass(index);
  }

  private getSingleStackClass(index: number): {[key: string]: boolean} | undefined {
    if (this.isFirstInStack(index)) {
      return {button_left: true};
    }

    if (this.isLastInStack(index)) {
      return {button_right: true};
    }
  }

  private getMultipleStackClass(index: number): {[key: string]: boolean} | undefined {
    const isFirstStack = this.isFirstStack(index);
    const isLastStack = this.isLastStack(index);
    const isFirstInStack = this.isFirstInStack(index);
    const isLastInStack = this.isLastInStack(index);

    if (isFirstStack && isFirstInStack) {
      return {button_top_left: true};
    }

    if (isFirstStack && isLastInStack) {
      return {button_top_right: true};
    }

    if (isLastStack && isFirstInStack) {
      return {button_bottom_left: true};
    }

    if (isLastStack && isLastInStack) {
      return {button_bottom_right: true};
    }
  }

  private isFirstInStack(index: number): boolean {
    return index % this.ITEMS_PER_STACK === 0;
  }

  private isLastInStack(index: number): boolean {
    return (index + 1) % this.ITEMS_PER_STACK === 0;
  }

  private isFirstStack(index: number): boolean {
    return index < this.ITEMS_PER_STACK;
  }

  private isLastStack(index: number): boolean {
    return index >= (this.stacks - 1) * this.ITEMS_PER_STACK;
  }
}
